import * as React from "react";
interface props {
  className?: string;
}
const SealCheckSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    className={className}
    fill="none"
    viewBox="0 0 38 38"
  >
    <path
      fill="#000"
      d="M33.526 15.262c-.56-.585-1.138-1.187-1.357-1.717-.201-.486-.213-1.29-.225-2.07-.022-1.448-.046-3.09-1.188-4.231s-2.783-1.165-4.232-1.188c-.779-.012-1.584-.024-2.069-.225-.528-.219-1.132-.797-1.717-1.357C21.713 3.49 20.55 2.375 19 2.375s-2.712 1.115-3.738 2.099c-.585.56-1.187 1.138-1.717 1.357-.482.201-1.29.213-2.07.225-1.448.023-3.09.046-4.231 1.188s-1.158 2.783-1.188 4.232c-.012.779-.024 1.583-.225 2.069-.219.528-.797 1.133-1.357 1.717C3.49 16.287 2.375 17.45 2.375 19s1.115 2.712 2.099 3.738c.56.585 1.138 1.187 1.357 1.717.201.486.213 1.29.225 2.07.023 1.448.046 3.09 1.188 4.231s2.783 1.166 4.232 1.188c.779.012 1.583.024 2.069.225.528.219 1.133.798 1.717 1.357 1.025.984 2.188 2.099 3.738 2.099s2.712-1.115 3.738-2.099c.585-.56 1.187-1.138 1.717-1.357.486-.201 1.29-.213 2.07-.225 1.448-.022 3.09-.046 4.231-1.188s1.166-2.783 1.188-4.232c.012-.779.024-1.584.225-2.069.219-.528.798-1.132 1.357-1.717.984-1.025 2.099-2.188 2.099-3.738s-1.115-2.712-2.099-3.738m-7.748 1.016-8.313 8.312a1.187 1.187 0 0 1-1.68 0l-3.563-3.562a1.189 1.189 0 0 1 1.68-1.68l2.723 2.723 7.472-7.474a1.19 1.19 0 0 1 2.029.84 1.2 1.2 0 0 1-.348.84"
    ></path>
  </svg>
);

export default SealCheckSvg;
